module.exports = __webpack_public_path__ + "static/media/o3x2_temp.66fa684d.jpg";